wbApp.controller('ContractTemplateDetailDialogCtrl', ['$scope', 'contractTemplateSvc',
function ($scope, contractTemplateSvc) {

    $scope.model = $scope.model ?? contractTemplateSvc.createNew();
    $scope.modelOrig = angular.copy($scope.model);
    
    $scope.isSaving = false;
    $scope.isLoading = false;
    
    $scope.onContractTemplateTypeChange = function(typeId)
    {
        $scope.isLoading = true;
        contractTemplateSvc.getSampleByType(typeId).$promise.then(function(templateSample) {
            $scope.model.templateData = templateSample.templateData;
            $scope.isLoading = false;
        }, function(err) {
            $scope.isLoading = false;
        })
    }

    if (!$scope.model.id) {
        $scope.onContractTemplateTypeChange(0);
    }

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };

    $scope.onDetailSave = function (model) {

        if ($scope.isSaving || $scope.isLoading) {
            return;
        }

        $scope.isSaving = true;

        function success(data) {
            if (!!$scope.onSaveSuccessful) {
                $scope.onSaveSuccessful(data);
            }
            $scope.$hide();
        }

        function error(data) {
            $scope.isSaving = false;
            $scope.detailError = data;
        }

        if (!model.id) {
            contractTemplateSvc.insert(model).$promise.then(success, error);
        } else {
            contractTemplateSvc.update(model).$promise.then(success, error);
        }        
    }

}]);
